export function isArrowKey(event) {
  return event?.event?.keyCode ? event.event.keyCode === 40 || event.event.keyCode === 38 : false
}
export function isESCKey(event) {
  return event?.event?.keyCode ? event.event.keyCode === 27 : false
}
